import type {RouteObject} from "react-router-dom";
import {createBrowserRouter} from "react-router-dom";
import Layout from "../Primereact/layout/Layout";
import NotFound from "../Auth/NotFound";
import Login from "../Auth/Login";
import Error from "../Auth/Error";
import Register from "../Auth/Register";
import NewPassword from "../Auth/NewPassword";
import LockScreen from "../Auth/LockScreen";
import Verification from "../Auth/Verification";
import {createElement, ReactNode, Suspense} from "react";
import PermissionGate from "../Auth/PermissionGate";
import PrivateRoute from "../PrivateRoute/PrivateRoute";
import {ModuleRouteObject} from "../types/permission";
import AuthLoader from "../Loader/AuthLoader";

// @ts-ignore
const context = require.context("../modules", true, /routes\.tsx$/);

const routeModules = context.keys().map((key:any) => {
    return context(key);
});

const PageFallback = () =>
    createElement(AuthLoader);

const withSuspense=(node: ReactNode): ReactNode => {
    return createElement(Suspense, { fallback: createElement(PageFallback) }, node);
}

function collectModuleRoutes(): RouteObject[] {
    return Object.entries(routeModules).flatMap(([filePath, mod]) => {
        // @ts-ignore
        if (!Array.isArray(mod.routes)) {
            console.warn(`[router] "${filePath}" has no "routes" export — skipping.`);
            return [];
        }
        // @ts-ignore
        return mod.routes.map(wrapRoute);
    });
}

const wrapRoute=(route: ModuleRouteObject): RouteObject => {
    const { permission, requireAuth = true, children, element, ...rest } = route;
    const wrappedChildren = children?.map(wrapRoute);
    const suspenseElement = withSuspense(element as ReactNode);

    const pageRoute: any = {
        ...rest,
        element: suspenseElement,
        ...(wrappedChildren ? { children: wrappedChildren } : {}),
    };

    // Public route — no guards
    if (!requireAuth) return pageRoute;

    // Permission gate (only if declared)
    const gated: RouteObject = permission ? { element: createElement(PermissionGate, { permission }), children: [pageRoute] } : pageRoute;

    // Auth guard
    return {
        element: createElement(PrivateRoute),
        children: [gated],
    };
}

export const router = createBrowserRouter([
    {
        path: "/",
        element: createElement(Layout),
        errorElement: <NotFound/>,
        children: [
            ...collectModuleRoutes(),
        ],
    },
    {
        path: '/auth',
        children: [
            {

                path: "login",
                element: createElement(Login),
            },
            {
                path: "register",
                element: createElement(Register),
            },
            {
                path: "new-password",
                element:createElement(NewPassword),
            },
            {
                path: "error",
                element: createElement(Error),
            },
            {
                path: "lock-screen",
                element: createElement(LockScreen),
            },
            {
                path: "verification",
                element: createElement(Verification),
            },
        ],
    },
]);

